module.exports = __webpack_public_path__ + "static/media/Tea.1953bb47.png";